import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=6c66f030&scoped=true"
import script from "./DownloadReport.vue?vue&type=script&lang=js"
export * from "./DownloadReport.vue?vue&type=script&lang=js"
import style0 from "./DownloadReport.vue?vue&type=style&index=0&id=6c66f030&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66f030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c66f030')) {
      api.createRecord('6c66f030', component.options)
    } else {
      api.reload('6c66f030', component.options)
    }
    module.hot.accept("./DownloadReport.vue?vue&type=template&id=6c66f030&scoped=true", function () {
      api.rerender('6c66f030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/screeningDataInfo/DownloadReport.vue"
export default component.exports